module.exports = __webpack_public_path__ + "mc.5d5286e1a57a5638b6e0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mc.svg
// module chunks = styles